import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import router from "@/router";
import { API_URI, USER, MEAL_REQUESTS } from "./apiConst";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: null,
    isLoggedIn: localStorage.fwt ? true : false,
    newUser: null,
    isAuthInProgress: false,
    zipCode: null || localStorage.zipCode,
    mealsRequestedInZipCode: null,
    hasApplied: null || localStorage.hasApplied
  },
  getters: {
    isLoggedIn: state => {
      return state.isLoggedIn;
    },
    isNewUser: state => {
      return state.newUser;
    },
    isAuthInProgress: state => {
      return state.isAuthInProgress;
    },
    getZipCode: state => {
      console.log(state);
      return state.zipCode;
    },
    getMealRequests: state => {
      return state.mealsRequestedInZipCode;
    },
    hasApplied: state => {
      return state.hasApplied;
    }
  },
  mutations: {
    networkCalled(state) {
      state.isAuthInProgress = true;
    },
    networkReturned(state) {
      state.isAuthInProgress = false;
    },
    firebaseLogin(state, data) {
      state.currentUser = data;
      state.isLoggedIn = true;
      localStorage.fwt = data.stsTokenManager.accessToken;
      localStorage.displayName = data.displayName;
      localStorage.uid = data.uid;
      localStorage.email = data.email;
      localStorage.hasApplied = data.hasApplied;
    },
    doesUserExist(state, data) {
      console.log(data);
      if (data.message) {
        state.newUser = true;
      } else {
        state.newUser = false;
      }
    },
    addZipCode(state, zipCode) {
      state.zipCode = zipCode;
      localStorage.zipCode = zipCode;
    },
    addMeals(state, meals) {
      state.mealsRequestedInZipCode = meals;
    },
    logout(state) {
      state.currentUser = null;
      state.userProfile = {};
      localStorage.removeItem("uid");
      localStorage.removeItem("fwt");
      localStorage.removeItem("email");
      localStorage.removeItem("displayName");
      localStorage.removeItem("zipCode");
      localStorage.removeItem("hasApplied");
    },
    requestMeal(state) {
      state.hasApplied = true;
      localStorage.hasApplied = true;
    }
  },
  actions: {
    async refreshFirebaseAuthToken() {
      // TODO
    },
    async getDashboardData(context, data) {
      const fwt = localStorage.fwt;
      const call = await fetch(`${API_URI}${MEAL_REQUESTS}`, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.fwt}`,
          Accept: "application/json",
          Origin: "*"
        }
      });
      const callJSON = await call.json();
      // handle expired token
      // else
      if (callJSON.meals || callJSON.meals === 0) {
        context.commit("addMeals", callJSON.meals);
      }
    },
    async dispatchRequestMeal(context, data) {
      const call = await fetch(`${API_URI}${MEAL_REQUESTS}`, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.fwt}`,
          Accept: "application/json",
          Origin: "*"
        },
        body: JSON.stringify({
          location: localStorage.zipCode
        })
      });
      const callJSON = await call.json();
      // handle the things

      context.commit("requestMeal", data);
    },
    async dispatchDoesUserExist(context, data) {
      // add login details
      console.log("hit dispatch");
      context.commit("firebaseLogin", data);
      // check if user exists
      context.commit("networkCalled");
      const call = await fetch(`${API_URI}${USER}`, {
        method: "GET",
        mode: "cors",

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.fwt}`,
          Accept: "application/json",
          Origin: "*"
        }
      });

      const callJSON = await call.json();
      // {message: "user from token does not exist in database"}message: "user from token does not exist in database"__proto__: Object
      /* {id: 2, firebase_id: "ee9JYpYijKSwpTrSrDNFV3bxLPG3", zipcode: "94536"} */
      context.commit("doesUserExist", callJSON);
      if (!context.state.newUser) {
        context.commit("addZipCode", callJSON.zipcode);
      }
      context.commit("networkReturned");
    },
    async dispatchCreateUser(context, data) {
      const postDATA = JSON.stringify({
        zipcode: data.zipCode,
        userType: "eater"
      });
      const call = await fetch(`${API_URI}${USER}`, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.fwt}`,
          Accept: "application/json",
          Origin: "*"
        },
        body: postDATA
      });

      context.commit("addZipCode", data.zipCode);

      // handle create data
    },
    dispatchLogout(context) {
      firebase
        .auth()
        .signOut()
        .then(function(result) {
          context.commit("logout");
        });
    }
  }
});
